import { colors } from 'constants/colors';
import React from 'react';
import styled from '@emotion/styled';
export default (props) => {
    const { text } = props;
    return React.createElement(Text, null, text);
};
const Text = styled.p `
  margin-bottom: 52px;
  font-size: 32px;
  font-weight: 500;
  line-height: 1.25;
  text-align: center;
  white-space: pre-wrap;
  color: ${colors[405766]};
`;
